export default "__VITE_ASSET__zUDewRrH__"